import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  conversations: [],
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(
  state: State,
  { conversations }: Boundaries["retrieveConversations"]["success"],
): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    conversations,
  };
}

function handleFailure(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isFailure: true },
  };
}

function handleConversationDeletion(
  state: State,
  { conversationId }: Boundaries["deleteConversation"]["success"],
): State {
  return {
    ...state,
    conversations: state.conversations.filter(
      (conversation) => conversation.uuid !== conversationId,
    ),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveConversationsRequested]: handleRequest,
    [events.retrieveConversationsSucceeded]: handleSuccess,
    [events.retrieveConversationsFailed]: handleFailure,
    [events.deleteConversationSucceeded]: handleConversationDeletion,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveConversationsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveConversationsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveConversationsRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getChatConversations() {
      return getState().conversations;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
